import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaInstagram } from "react-icons/fa"; // Import Instagram Icon
// import { Button } from "./Button";
import "./Navbar.css";

function Navbar() {
  const [click, setClick] = useState(false);
  const location = useLocation();

  const handleLinkClick = (targetPath) => {
    if (location.pathname === targetPath) {
      // If already on the target page, scroll to the top instantly
      window.scrollTo({ top: 0, behavior: "instant" });
    }
    closeMobileMenu(); // Close the mobile menu
    // handleClick();
  };

  const closeMobileMenu = () => setClick(false);

  const [button, setButton] = useState(true);

  const [menuTop, setMenuTop] = useState(0);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  const handleClick = () => {
    setClick(!click);
    if (!click) {
      // Update the top position when opening the menu
      setMenuTop(window.scrollY);
    }
  };

  window.addEventListener("resize", showButton);

  return (
    <>
      <nav className="navbar">
        <div className="navbar-container">
          <Link to="/" className="navbar-logo" onClick={() => handleLinkClick("/")}>
            <img src="/images/logos/logo-white.webp"></img>
          </Link>
          <div className="menu-icon" onClick={handleClick}>
            <i className={click ? "fas fa-times" : "fas fa-bars"}></i>
          </div>
          <ul
            className={click ? "nav-menu active" : "nav-menu"}
            style={{ top: `${menuTop}px` }} // Dynamically set the menu's top position
          >
            <li className="nav-item">
              <Link to="/film" className="nav-links" onClick={() => handleLinkClick("/film/")}>
                35mm
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/aesthetics"
                className="nav-links"
                onClick={() => handleLinkClick("/aesthetics/")}
              >
                Aesthetics
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/" className="nav-links" onClick={() => handleLinkClick("/")}>
                Fashion
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/adverts"
                className="nav-links"
                onClick={() => handleLinkClick("/adverts/")}
              >
                Adverts
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/contact"
                className="nav-links"
                onClick={() => handleLinkClick("/contact/")}
              >
                Contact
              </Link>
            </li>
            <li className="nav-item instagram-link">
              <a
                href="https://www.instagram.com/augusts_autumn"
                target="_blank"
                rel="noopener noreferrer"
                className="nav-links-mobile"
                onClick={closeMobileMenu}
              >
                <FaInstagram size={32} style={{ marginRight: "8px" }} />
                
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
